import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { ManageLineService } from 'src/app/services/manage-line.service';
import { ChangeServiceService } from 'src/app/services/change-service.service';
import { HttpCacheService } from 'src/app/services/http-cache.service';
import { ANALYTICS, COMMON_CONSTANTS, RATEPLANSERVICE } from 'src/app/common/core/common.constants';
import * as _ from 'lodash';
import { isNullOrUndefined } from 'src/app/services/utils';
import { UtilsService } from 'src/app/services/utils.service';
import { PDLService } from 'src/app/services/pdl-service.service';

@Component({
  selector: 'app-evaluate-promotion',
  templateUrl: './evaluate-promotion.component.html',
  styleUrls: ['./evaluate-promotion.component.scss']
})
export class EvaluatePromotionComponent implements OnInit {
  authoringContentData: any;
  removingService:any;
  lineID:any;
  isPromo:any;
  currentServArray:any;
  selectedService: any;
  currentSelectedServices: any;
  servicesList: any;
  promotionDesc: any;
  addingServToGetConflictModal: any;
  currentConflictingServices:any;
  changeRatePlanFlow: boolean = false;
  @Output() confirmChange = new EventEmitter();

  constructor(public manageLineSvc: ManageLineService, private changeSvc: ChangeServiceService,
    private _cacheSvc: HttpCacheService , private utilsSvc : UtilsService,private pdlService: PDLService) { }

  ngOnInit() {
    this.changeRatePlanFlow = Boolean(JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.CHANGE_RATE_PLAN_FLOW))) ? true : false;
    this.authoringContentData = JSON.parse(this._cacheSvc.getFromSessionStorage(COMMON_CONSTANTS.CONTENT));
    
    let modalInfo = {
      eventAction: ANALYTICS.LOAD,
      modalName:this.authoringContentData.changeService.promotionHeader,
    };
    if(this.changeRatePlanFlow){
      modalInfo['stage'] = this.authoringContentData.changeRatePlan.inProgress
      modalInfo['name'] = this.authoringContentData.changeRatePlan.changeRatePlanText
    }
    this.pdlService.ifEnabledGenerateModalViewTag(modalInfo);
  }
  getCurrentConflictingServices() {
    if (!isNullOrUndefined(this.addingServToGetConflictModal)) {
      const conflictingSocs = <any[]>this.addingServToGetConflictModal.currentlyConflictingWith;
      _.each(this.servicesList, (item) => {
        _.each(conflictingSocs, (soc) => {
          if (item.soc === soc) {
            this.currentConflictingServices.push(item);
          }
        });
      });
    }
  }
  acceptAndContinue() {
    if(!_.isUndefined(this.addingServToGetConflictModal)){
      this.addingServToGetConflictModal.isSelected = true;
      if (this.currentSelectedServices.find((test) => test.soc === this.addingServToGetConflictModal.soc) === undefined) {
        this.currentSelectedServices.push(this.addingServToGetConflictModal);
      }
      _.each(this.currentConflictingServices, (item) => {
        item.isSelected = false;
        const indexOfSocV2 = this.getIndexOfSocV2(this.currentSelectedServices, item.soc);
        if(indexOfSocV2 !== -1){
          this.currentSelectedServices.splice(indexOfSocV2, COMMON_CONSTANTS.DIGITS.ONE);
        }
      });
    }
    this.selectedService.isSelected = false;
    const index = this.getIndexOfSocV2(this.currentSelectedServices, this.selectedService.soc);
    if(index !== -1){
      this.currentSelectedServices.splice(index,COMMON_CONSTANTS.DIGITS.ONE);
    }
    if(this.changeRatePlanFlow){
      _.each(this.servicesList,(servList)=>{
        if(this.selectedService.soc === servList.soc){
          servList.isSelected = this.selectedService.isSelected;
        }
      });
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.SERVICE_LIST, JSON.stringify(this.servicesList));
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
      this.nextButtonEnable();
    }
    this.changeSvc.serviceSelectionChanged.next(true);
    this.manageLineSvc.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: this.authoringContentData.changeService.acceptBtn,
      assetType: ANALYTICS.BUTTON,
      modalName:this.authoringContentData.changeService.promotionHeader,
    });
  }
  updateMainList(){
    this.currentSelectedServices = JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE));
    this.servicesList = JSON.parse(this._cacheSvc.getFromSessionStorage(RATEPLANSERVICE.SERVICE_LIST));
    _.each(this.currentSelectedServices,(currentList)=>{
      _.each(this.servicesList,(servList)=>{
        if(currentList.soc === servList.soc){
          servList.isSelected = currentList.isSelected;
        }
      });
    });
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.SERVICE_LIST, JSON.stringify(this.servicesList));
    this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
    this.nextButtonEnable();
  }
  /** consider 2 socs,
       * soc1 - current service, soc2 - eligible service (conflicting with soc1)
       * on adding soc2, soc1 has to be removed.
       * below addingServToGetConflictModal is soc2
       * selectedService is soc1*/
  onClickPromoClose(event?:any){
    let buttonName:any;
    if(!isNullOrUndefined(event) && !isNullOrUndefined(event.currentTarget) && !isNullOrUndefined(event.currentTarget.innerText) && event.currentTarget.innerText === this.authoringContentData.changeService.cancelTxt){
     buttonName = this.authoringContentData.changeService.cancelTxt;
    }else{
     buttonName = ANALYTICS.CLOSE;
    }
    this.selectedService.isSelected = true;
    if (this.currentSelectedServices.find((test) => test.soc === this.selectedService.soc) === undefined) {
      this.currentSelectedServices.push(this.selectedService);
    }
    if(!_.isUndefined(this.addingServToGetConflictModal)){
      this.addingServToGetConflictModal.isSelected = false;
      const index = this.getIndexOfSocV2(this.currentSelectedServices, this.addingServToGetConflictModal.soc);
      if(index !== -1){
        this.currentSelectedServices.splice(index,COMMON_CONSTANTS.DIGITS.ONE);
      }
    }
    if(this.changeRatePlanFlow){
      _.each(this.servicesList,(servList)=>{
        if(!_.isUndefined(this.addingServToGetConflictModal) && this.addingServToGetConflictModal.soc === servList.soc){
          servList.isSelected = this.addingServToGetConflictModal.isSelected;
        }else if(this.selectedService.soc === servList.soc){
          servList.isSelected = this.selectedService.isSelected;
        }
      });
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.SERVICE_LIST, JSON.stringify(this.servicesList));
      this._cacheSvc.putInSessionStoarage(RATEPLANSERVICE.CURRENT_SELECTED_SERVICE, JSON.stringify(this.currentSelectedServices));
      this.updateMainList();
    }
    this.changeSvc.serviceSelectionChanged.next(true);
    this.manageLineSvc.close();
    this.pdlService.ifEnabledGenerateClickTag({
      type: ANALYTICS.CLICK_TO_NAVIGATE,
      action: ANALYTICS.CLICK,
      ctaName: buttonName ,
      assetType: ANALYTICS.BUTTON,
      modalName:this.authoringContentData.changeService.promotionHeader,
    });
  }
  getIndexOfSocV2(array: any[], item) {
    let index = -1;
    _.each(array, (service, ind) => {
      if (service.soc === item) {
        index = ind;
      }
    });
    return index;
  }
  nextButtonEnable(){
    let enableButton: boolean;
    enableButton= this.utilsSvc.nextButtonEnable();
    if(enableButton){
      this.confirmChange.emit(true);
    }
    else{
      this.confirmChange.emit(false);
    }
  }

}
